module.exports = __webpack_public_path__ + "static/media/error.9b5feaa7.wav";